import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_1: FaireProductEntity = {
  token: "atc_nf_chunks_1",
  type: "product",
  name: "Checker Claw in Black + White",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/files/CheckerClawBlackWhiteSilo.jpg?v=1732069516",
  priceDollars: 18.95,
  msrpDollars: 38,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
